
    import { defineComponent } from 'vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'ContractFinish',
        props: {
            titleAndPromotionDetails: {
                type: Object as () => TitleAndPromotionsDetails,
                required: true,
            }
        },
        data() {
            return {
                externalIdentifier: null,
            }
        },
        mounted() {
            this.externalIdentifier = sessionStorage.getItem("PricingId");
        }
    });
